<template>
  <div>
    <div class="background"></div>
    <sidebar @testeshow="TrocaShow"></sidebar>
    <transition name="slide">
      <div :style="{ position: 'relative', left : larguraRouter+'px', transition: '0.6s'}">
        <router-view></router-view>
      </div>
    </transition>
  </div>
</template>

<script>
//listener
import Sidebar from "../../components/SideHeaderDashboard";
export default {
  data() {
    return {
      larguraRouter: 0,
      show: false
    };
  },
  methods: {
    TrocaShow() {
      this.show = !this.show;
      if (this.show) {
        this.larguraRouter = /*this.TamanhoSidebar -760*/ 150;
      } else {
        this.larguraRouter = /*this.TamanhoSidebar -925*/ 0;
      }
    }
  },
  components: {
    sidebar: Sidebar
  }
};
</script>

<style scoped>
.background {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: #f5f5f5;
}

.slide-enter-active,
.slide-leave-active {
  transition: 0.3s;
}
.slide-enter,
.show-leave-to {
  transform: translateX(-241);
}
</style>